// src/store/slices/configSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "../../types";

// Initial state for the auth slice
const initialState: config.ConfigStateType = {
  appLayout: {
    showBottomBar: true,
  },
  reminders: {
    data: null,
    isLoading: false,
    error: null,
  },
};

// Define the config slice
const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    // set layout properties
    setLayoutProperties: (
      state: config.ConfigStateType,
      action: PayloadAction<any>
    ) => {
      state.appLayout = { ...state.appLayout, ...action.payload };
    },
    // get reminders
    getRemindersRequest: (
      state: config.ConfigStateType,
      action: PayloadAction<any>
    ) => {
      state.reminders.isLoading = true;
      state.reminders.data = null;
      state.reminders.error = null;
    },
    getRemindersSuccess: (
      state: config.ConfigStateType,
      action: PayloadAction<any>
    ) => {
      state.reminders.isLoading = false;
      state.reminders.data = action.payload;
      state.reminders.error = null;
    },
    getRemindersError: (
      state: config.ConfigStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.reminders.isLoading = false;
      state.reminders.data = null;
      state.reminders.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // set layout properties
  setLayoutProperties,

  // get reminders
  getRemindersRequest,
  getRemindersSuccess,
  getRemindersError,
} = configSlice.actions;

export default configSlice.reducer;
